import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const NavBar: React.FC = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const isApproved = user && (user.status === "approved" || user.status === "paid");
  const isAdmin = user?.role === "admin";
  const isEditor = user?.role === "editor";

  return (
    <header className="navbar">
      <div className="navbar-left">
        <span className="logo">ISB Toolbox</span>
      </div>

      <button className="hamburger" onClick={() => setOpen(!open)} aria-label="Menu">
        ☰
      </button>

      <nav className={`nav-links ${open ? "open" : ""}`}>
        {!user && (
          <>
            <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
            <Link to="/register" onClick={() => setOpen(false)}>Registrieren</Link>
          </>
        )}

        {user && (
          <>
            {isApproved && (
              <Link to="/" onClick={() => setOpen(false)}>News</Link>
            )}
            {isApproved && (
              <Link to="/tools" onClick={() => setOpen(false)}>Tools (bald)</Link>
            )}
            {(isAdmin || isEditor) && (
              <Link to="/admin/news" onClick={() => setOpen(false)}>Admin News</Link>
            )}
            {isAdmin && (
              <Link to="/admin/users" onClick={() => setOpen(false)}>Admin Users</Link>
            )}
            <button className="logout-btn" onClick={logout}>Logout</button>
          </>
        )}
      </nav>
    </header>
  );
};
